export * from "./target-property";
